import { render } from "./BorderedTeam.vue?vue&type=template&id=265079e6&ts=true"
import script from "./BorderedTeam.vue?vue&type=script&lang=ts"
export * from "./BorderedTeam.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__